import { useTheme } from '@mui/material';

const CameraClipIcon = () => {
  const theme = useTheme();

  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2348 16.9505C18.2348 17.6529 17.6654 18.2224 16.9629 18.2224C16.2605 18.2224 15.691 17.6529 15.691 16.9505C15.691 16.248 16.2605 15.6786 16.9629 15.6786C17.6654 15.6786 18.2348 16.248 18.2348 16.9505ZM19.9307 16.9505C19.9307 18.0312 19.3531 18.977 18.4897 19.4959L21.4594 21.1507L28.8968 17.0064C29.2547 16.8069 29.7066 16.9354 29.906 17.2934C30.1055 17.6513 29.977 18.1032 29.6191 18.3026L22.9837 22.0001L29.6191 25.6974C29.977 25.8969 30.1055 26.3487 29.906 26.7067C29.7066 27.0646 29.2547 27.1931 28.8968 26.9937L21.4594 22.8494L18.4897 24.5042C19.3531 25.0232 19.9307 25.969 19.9307 27.0497C19.9307 28.6888 18.602 30.0175 16.9629 30.0175C15.3239 30.0175 13.9952 28.6888 13.9952 27.0497C13.9952 25.8792 14.6729 24.8669 15.6573 24.3838L19.9352 22.0001L15.6568 19.6161C14.6726 19.1329 13.9952 18.1208 13.9952 16.9505C13.9952 15.3114 15.3239 13.9827 16.9629 13.9827C18.602 13.9827 19.9307 15.3114 19.9307 16.9505ZM18.2348 27.0497C18.2348 26.3472 17.6654 25.7778 16.9629 25.7778C16.2605 25.7778 15.691 26.3472 15.691 27.0497C15.691 27.7522 16.2605 28.3217 16.9629 28.3217C17.6654 28.3217 18.2348 27.7522 18.2348 27.0497Z"
        fill={theme.palette.background.paper}
      />
    </svg>
  );
};

export default CameraClipIcon;
